import { contractApi } from '../contractApi';
import { MedicareContractOptionView } from '../types/contractTypes';
import { FinancialClassView, CalcTypeView, FacilityTypeView } from '../types/dimensionTypes';

const dimensionEndpoints = contractApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all financial classes
    getFinancialClasses: builder.query<FinancialClassView[], void>({
      query: () => ({
        url: 'dimensions/financial-classes',
        method: 'GET',
      }),
      providesTags: ['FinancialClass'],
    }),

    // Get all calculator types
    getCalcTypes: builder.query<CalcTypeView[], void>({
      query: () => ({
        url: 'dimensions/calc-types',
        method: 'GET',
      }),
      providesTags: ['CalcType'],
    }),

    // Get all facility types
    getFacilityTypes: builder.query<FacilityTypeView[], void>({
      query: () => ({
        url: 'dimensions/facility-types',
        method: 'GET',
      }),
      providesTags: ['FacilityType'],
    }),

    // Get Medicare contracts for dropdown
    getMedicareContracts: builder.query<MedicareContractOptionView[], { company: string }>({
      query: ({ company }) => ({
        url: 'ContractsGetMedicare',
        method: 'GET',
        params: { company },
      }),
      providesTags: ['MedicareContracts'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetFinancialClassesQuery,
  useGetCalcTypesQuery,
  useGetFacilityTypesQuery,
  useGetMedicareContractsQuery,
} = dimensionEndpoints;
